export const DEFAULT_SALES_TERMS = `SATIŞ KOŞULLARI
1- İş bu belge üzerinde yer alan ürünler ve fiyatlar ile sınırlıdır. Nakliye alıcıya aittir. Karalama ve oynama olması durumunda belge geçersizdir.

ÖDEME ŞARTLARI :
a) Fiyatlarımız DOLAR/adet cinsinden verilmiştir.
b) Vadesinde ödenmeyen miktarlar için aylık %5 gecikme farkı uygulanacaktır.
c) Ödeme Tutarı: Sevk günü sipariş tarihindeki TCMB dolar efektif sipariş kuru baz alınacaktır.
d) Ürünlerin sevkiyatından önce: Sözleşme tutarının tamamı ödenmeden sevkiyat yapılmamaktadır.
e) Alıcının siparişten vazgeçmesi halinde sipariş tutarının %20'si iptal bedeli olarak tahsil edilir.
f) Ödemenin tamamı yapılana kadar mal sahibi NEF MAKİNE ENDÜSTRİYEL SAN. A.Ş. dir.
g) Anlaşmazlık olması halinde GAZİANTEP mahkemeleri ve icra daireleri yetkilidir.
h) Alıcı firma MÜŞTERİ YETKİLİ ONAYI kısmını imzaladığı anda yukarıdaki maddeleri peşinen kabul etmiş sayılır.
i) Ödeme şartlarına uyulmaması halinde satıcı sözleşmeyi feshedebilir.
j) Firmamız ihbar etmeksizin fiyat, ölçü ve teknik özellikleri değiştirme hakkını saklı tutar.`;

/** @deprecated use DEFAULT_SALES_TERMS */
export const DEFAULT_PDF_DESCRIPTION = DEFAULT_SALES_TERMS;

export const DEFAULT_TESLIMAT_YONTEMI = "TESLİM";
export const DEFAULT_OPSIYON_SURESI = "3 İŞ GÜNÜ";
export const DEFAULT_EK_BILGI_NOTU = "FİYATLAR, 24 SAAT İÇİN GEÇERLİDİR.";

export const TESLIMAT_YONTEMI_OPTIONS = [
  { value: "TESLİM", label: "Teslim" },
  { value: "FABRİKADAN TESLİM", label: "Fabrikadan Teslim" },
  { value: "NAKLİYE ALICIYA AİT", label: "Nakliye alıcıya ait" },
  { value: "FİRMA DEPOSUNDAN TESLİM", label: "Firma deposundan teslim" },
  { value: "MÜŞTERİ ADRESİNE SEVK", label: "Müşteri adresine sevk" },
];

export function resolveOrderSalesTerms(order) {
  const raw = String(order?.pdfDescription || "").trim();

  if (raw) {
    if (raw.includes("SATIŞ KOŞULLARI")) {
      const idx = raw.indexOf("SATIŞ KOŞULLARI");
      return raw.slice(idx).trim();
    }
    return raw;
  }

  if (order?.pdfContent?.salesTerms?.trim()) {
    const terms = order.pdfContent.salesTerms.trim();
    return terms.startsWith("SATIŞ KOŞULLARI")
      ? terms
      : `SATIŞ KOŞULLARI\n${terms}`;
  }

  return DEFAULT_SALES_TERMS;
}

export const DEFAULT_BANK_INFO = {
  bankRecipientName: "NEF MAKİNE ENDÜSTRİYEL SANAYİ A.Ş.",
  bankBranchName: "Ziraat Bankası / Gaziantep Binevler Şubesi",
  bankIban: "TR28 0001 0019 5597 6579 7650 01",
};

export function resolveOrderBankInfo(order) {
  const accounts = resolveOrderBankAccounts(order);
  return accounts[0] || DEFAULT_BANK_INFO;
}

export function resolveOrderBankAccounts(order) {
  if (Array.isArray(order?.bankAccounts) && order.bankAccounts.length > 0) {
    return order.bankAccounts.map((account) => ({
      bankRecipientName:
        account?.bankRecipientName?.trim() || DEFAULT_BANK_INFO.bankRecipientName,
      bankBranchName:
        account?.bankBranchName?.trim() || DEFAULT_BANK_INFO.bankBranchName,
      bankIban: account?.bankIban?.trim() || DEFAULT_BANK_INFO.bankIban,
    }));
  }

  const legacy = {
    bankRecipientName:
      order?.bankRecipientName?.trim() || DEFAULT_BANK_INFO.bankRecipientName,
    bankBranchName:
      order?.bankBranchName?.trim() || DEFAULT_BANK_INFO.bankBranchName,
    bankIban: order?.bankIban?.trim() || DEFAULT_BANK_INFO.bankIban,
  };

  if (
    order?.bankRecipientName?.trim() ||
    order?.bankBranchName?.trim() ||
    order?.bankIban?.trim()
  ) {
    return [legacy];
  }

  return [DEFAULT_BANK_INFO];
}

export function resolveOrderDeliveryMeta(order) {
  return {
    teslimatYontemi:
      order?.teslimatYontemi?.trim() ||
      order?.pdfContent?.teslimatYontemi?.trim() ||
      DEFAULT_TESLIMAT_YONTEMI,
    opsiyonSuresi:
      order?.opsiyonSuresi?.trim() ||
      order?.pdfContent?.opsiyonSuresi?.trim() ||
      DEFAULT_OPSIYON_SURESI,
    ekBilgiNotu:
      order?.ekBilgiNotu?.trim() ||
      order?.pdfContent?.ekBilgiNotu?.trim() ||
      DEFAULT_EK_BILGI_NOTU,
  };
}
